import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'rounder'})
export class RounderPipe implements PipeTransform {

  /**
   * Pipe method transform.
   *
   * @param value
   * @param rounder
   *
   * Return rounded price value.
   */
  transform(value: number = 0, rounder?: number): any {

    if (rounder > 0) {
      return new Intl.NumberFormat().format(+value.toFixed(rounder));
    }
    switch (true) {
      case this.getDecimalPlacesLength(value) > 4:
        return new Intl.NumberFormat().format(+value.toFixed(5));
      case this.getDecimalPlacesLength(value) === 4:
        return new Intl.NumberFormat().format(+value.toFixed(4));
      case this.getDecimalPlacesLength(value) === 3:
        return new Intl.NumberFormat().format(+value.toFixed(3));
      case this.getDecimalPlacesLength(value) === 2:
        return new Intl.NumberFormat().format(+value.toFixed(2));
      case  this.getDecimalPlacesLength(value) === 0:
        return new Intl.NumberFormat().format(+value.toFixed(2)) + '.00';
      default:
        return value ? new Intl.NumberFormat().format(+value.toFixed(2)) + '0' : '0.00';
    }

  }


  /**
   * Get fractional of number.
   *
   * @param value number.
   *
   * Return length decimal places.
   */
  getDecimalPlacesLength(value: number): number {
    const fractional = String(value).split('.');
    const decimals = fractional.length > 1 ? fractional[1].length : 0;
    return Number(decimals);
  }
}
